(function() {
	'use strict';
	var $ = avm.require('cash'),
		$buttons = $('.js-tab-link'),
		$tabs = $('.nav-link'),
		$contents = $('.tab-pane');

	//Active proper tab
	$buttons.on('click', function() {
		var $index = $(this).attr('data-target'),
			$tab = $($tabs.get($index-1)),
			$content = $($contents.get($index-1));

		$tabs.removeClass('active').attr('aria-selected','false').attr('tabindex',-1);
		$contents.removeClass('active show');

		$tab.addClass('active').attr('aria-selected','true').attr('tabindex',0).trigger("focus");
		$content.addClass('active show');
	});
})();


/* Carousels setting */
var tab1 = tns({
	"container": ".slider-tab1",
	"controlsContainer": ".slider-tab1-controls",
	"controlsPosition": "bottom",
	"preventScrollOnTouch": "auto",
	"controls": false,
	"navPosition": "bottom",
	"nav": true,
	"mouseDrag": true,
	"speed": 400,
	"loop": false,
	"fixedWidth": 280,
	"slideBy": 1,
	"responsive": {
		"992": {
			"controls": true
		},
		"1280": {
			"fixedWidth": 316
		}
	}
});
var tab2 = tns({
	"container": ".slider-tab2",
	"controlsContainer": ".slider-tab2-controls",
	"controlsPosition": "bottom",
	"preventScrollOnTouch": "auto",
	"controls": false,
	"navPosition": "bottom",
	"nav": true,
	"mouseDrag": true,
	"speed": 400,
	"loop": false,
	"fixedWidth": 280,
	"slideBy": 1,
	"responsive": {
		"992": {
			"controls": true
		},
		"1280": {
			"fixedWidth": 316
		}
	}
});
var tab3 = tns({
	"container": ".slider-tab3",
	"controlsContainer": ".slider-tab3-controls",
	"controlsPosition": "bottom",
	"preventScrollOnTouch": "auto",
	"controls": false,
	"navPosition": "bottom",
	"nav": true,
	"mouseDrag": true,
	"speed": 400,
	"loop": false,
	"fixedWidth": 280,
	"slideBy": 1,
	"responsive": {
		"992": {
			"controls": true
		},
		"1280": {
			"fixedWidth": 316
		}
	}
});
